import arcCampaignsSlice from './reducer'
import saga from './saga'
import * as selectors from './selectors'
import * as actions from './actions'

const reducer = arcCampaignsSlice.reducer

export { reducer, saga, selectors, actions }